import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleCallback } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    handleCallback()
      .then(() => navigate("/planner", { replace: true }))
      .catch((e) => setError(String(e)));
  }, [navigate]);

  if (error) {
    return (
      <div className="p-6 text-red-700">
        <p className="font-semibold">Sign-in failed</p>
        <pre className="mt-2 whitespace-pre-wrap text-sm">{error}</pre>
      </div>
    );
  }
  return <div className="p-6 text-slate-500">Completing sign-in…</div>;
}
